// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__Zd60-","info":"Note_info__1GClh","note":"Note_note__1MeSM","actions":"Note_actions__1o6Oi"};